import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class ProductService {

    getEventRoute = '/api/dbtproduct/';

    constructor(private dataService: DataService) {
    };

    save(result: any) {
        return this.dataService.post('/api/dbtproduct/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getMachinaryClassificationLookUp(refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/machinaryclassification', refresh);
    }

    productLock(result: any) {
        return this.dataService
          .post("/api/dbtproduct/lockproduct", result)
          .map((response) => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
          });
      }

    productApprove(result: any){
        return this.dataService.post('/api/dbtproduct/productapprove', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    productClarificationSave(result: any){
        return this.dataService.post('/api/dbtproduct/clarificationsave', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    productUpdate(result: any){
        return this.dataService.post('/api/dbtproduct/Update', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getMachinaryCategoryLookUp(machinaryCategoryId: any, refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/machinarycategory/' + machinaryCategoryId, refresh);
    }

    getTractorDriveTypeLookUp(refresh: boolean) {
        return this.dataService.getData('/api/lookup/tractordrivetype', refresh);
    }

    getPowerSourcenLookUp(refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/powersource', refresh);
    }

    // getProductLookUp(data: any, refresh: boolean) {
    //     return this.dataService.getData('/api/dbtproduct/' + data.machinaryClassificationId + '/' + data.machinaryCategoryId + '/' + data.tractorDriveType + '/' + data.powerSourceId, refresh);
    // }

    getProductLookUp(data: any) {
        return this.dataService.post('/api/dbtproduct/filterproduct', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    Productmappingsave(data: any) {
        return this.dataService.post('/api/dbtproduct/productmappingsave', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getApprovedProduct(id: number, year:number, refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/approvedproductlist/' + id+'/'+year, refresh);
    }

    getProductDropDownLookUp(data: any, refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/specList/' + data.machinaryClassificationId + '/' + data.machinaryCategoryId + '/' + data.powerSourceId, refresh);
    }

    getTestedFrom(refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/testingcentre', refresh);
    }

    getProduct(id: number,year:any, refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/productlist/' + id+'/'+year, refresh);
    }
    getProductDetail(id: number, refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/productDetail/' + id, refresh);
    }

    getgstList(refresh: boolean) {
        return this.dataService.getData('/api/dbtmanufacturer/gstlist', refresh);
    }

    delete(id: number, status: number,yearId:any) {
        return this.dataService.post('/api/dbtproduct/delete/' + id + '/' + status+'/'+yearId, null).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getProductEdit(refresh: boolean){
        return this.dataService.getData('/api/lookup/productedittype', refresh);
    }

    getProductInfo(id: number,financialyearId:number,refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/productInfoDetail/' + id +'/'+ financialyearId, refresh);
    }
    getProductInfo1(id: number,year:any, refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/productInfoDetail/' + id +'/'+year, refresh);
    }
    getProductTimeLine(id: number, refresh: boolean) {
        return this.dataService.getData(
          '/api/dbtproduct/timeline/' + id, refresh
        );
      }
    getTimeline(dbtBookingId:any,refresh:boolean){
        return this.dataService.getData('/api/dbtfarmertarget/timeline/'+dbtBookingId,refresh);
    }

    getPaccsTimeLine(bookingId:any,refresh:boolean){
        return this.dataService.getData('/api/paccsbooking/timeline/'+bookingId,refresh);
    }

    bookingApprovalJr(data)
    {
        return this.dataService.post('/api/paccsbooking/bookingapproval',data);

    }

    updatePriceSave(data)
    {
        return this.dataService.post('/api/dbtproductpricemapping',data);

    }

    getMachinaryCatAllLookup(refresh: boolean) {
        return this.dataService.getData('/api/dbtproduct/machinarycategory', refresh)
    }
    getmanufacturerLookup(refresh: boolean) {
        return this.dataService.getData('/api/lookup/allmanufacturertype', refresh)
    }
}
